import * as PIXI from 'pixi.js'
import * as filters from 'pixi-filters'
import Please from 'pleasejs'

const blur = new filters.KawaseBlurFilter(1, 6), 
      glow = new filters.GlowFilter({ distance: 33, outerStrength: 6, innerStrength: 0, color: 0xf32313, knockout: true })

const options = {
  width: window.innerWidth,
  height: window.innerHeight,
  transparent: true,
  antialias: true
}

const app = new PIXI.Application(options)
window.addEventListener('resize', () => {
  app.view.width = window.innerWidth
  app.view.height = window.innerHeight
}, false)

app.stage.filters = [blur, glow]
document.body.appendChild(app.view)

const shapePrototype = new PIXI.Graphics(), shapes = []
shapePrototype.lineStyle(0)
shapePrototype.beginFill(0xff0000, 1)
shapePrototype.drawCircle(0, 0, 40, 100)

shapePrototype.endFill()
shapePrototype.cacheAsBitmap = true

for (let i = 0, max = 90; i < max; i++) {
  const shape = shapePrototype.clone()
  shape.width = randomInt(6, 133) 
  shape.height = shape.width
  shape.x = randomInt(0, app.screen.width)
  shape.y = randomInt(0, app.screen.height)
  shape.direction = Math.random() * Math.PI / 2
  shape.speed = Math.random() * .5
  shape.turningSpeed = Math.random() * .666

  shape.alpha = 0.3
  shape.tint = parseInt(`${ (randomInt(250, 255)).toString(16) }${ (randomInt(28, 32)).toString(16) }00`, 16)

  shapes.push(shape)
  app.stage.addChild(shape)
}

app.ticker.add(delta => {
  for(let i=0, max=shapes.length; i<max; i++) {
    const shape = shapes[i]
    shape.x += Math.sin(shape.direction) * shape.speed
    shape.y += Math.cos(shape.direction) * shape.speed
    shape.direction += shape.turningSpeed * delta * 0.01
    shape.rotation = -shape.direction - Math.PI / 2
  }
})

function randomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function chance(probability = 0.5) {
  return Math.random() <= probability
}

